var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-check-16px",
  "use": "shape-check-16px-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill-rule=\"evenodd\" id=\"shape-check-16px\"><path d=\"M6.45 10.13L3.694 7.374l-1.42 1.41L6.45 12.96l7.05-7.05-1.41-1.41-5.64 5.63z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-check-16px.svg
// module id = 179
// module chunks = 72698250460545 114276838955818